import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Axios from "axios";
import moment from "moment";
import DatetimePicker from "vuetify-datetime-picker";

Vue.config.productionTip = false;

Vue.prototype.$http = Axios;
const token = localStorage.getItem("user-token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}

Vue.filter('formatDate', function (value) {
  if (value) {
    // console.log("formatDate", value);
    return moment(String(value)).format("MMM DD, YYYY");
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    // console.log("formatDateTime", value);
    return moment(String(value)).format("YYYY-MM-DD HH:mm");
  }
})


Vue.use(DatetimePicker);
Vue.use(moment);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");



